import React from 'react'

  const staticFooter = {
    backgroundColor: '#0a1a35',
    minHeight: '50px',
    width: '100%',
    display: 'flex',
    alignItems: "center",
    justifyContent: "center",
    color: "white",
    fontSize: "16px",
    justifySelf: "flex-end"
  }
  

export default function CMRoutes() {
    return (
        <div style={staticFooter}>
        Contact us: chronomirror@forteindiedev.com
        </div>
      );
}